const a = /\/(calendar|physicians)(\/|$)/, n = 'a[href^="/"]:not([href*="/calendar"]):not([href*="/physicians"])', E = 'a[href*="/calendar"], a[href*="/physicians"]';
export {
  E as INTERNAL_LINK_SELECTOR_MODULES,
  n as INTERNAL_LINK_SELECTOR_NOT_MODULES,
  a as LOCATION_MODULE_LINK_REGEX
};
